export enum WidgetType{
    IncomeBarChart,
    ExpenseBarChart,
    HasAssetsPieChart,
    HasAssetsNegativeBarChart,
    ReceivableList,
    DebtList,
    AgreedList,
    ManufactureOrders,
    CustomerBalance,
    /** Günlük kâr + işlem sayısı KPI kartları (modern tema). */
    DailyProfitKpi = 9,
    /** E-ticaret günlük ciro/sipariş KPI kartları. */
    EcommerceKpi = 10,
    /** Güncel parite/kur tablosu. */
    LiveMarket = 11,
    /** İşlem kısayolları paneli. */
    QuickActions = 12
}